import request from '@/utils/request'


export function index(params) {
    return request({
        url: '/settings/settingApp',
        method: 'get',
        params
    })
}

export function store(data) {
    return request({
        url: '/settings/settingApp',
        method: 'post',
        data
    })
}

export function getLang() {
    return request({
        url: '/settings/settingApp/getLang',
        method: 'get'
    })
}


